import React from 'react';
import Modal from '../modal/modal';

import './confirmation-modal.css';

class ConfirmationModal extends React.Component {

    onConfirm = () => {
        this.props.onConfirm && this.props.onConfirm();
        this.props.onClose();
    };

    onCancel = () => {
        this.props.onCancel && this.props.onCancel();
        this.props.onClose();
    };

    render() {
        const msg = this.props.msg ? this.props.msg : 'Deseja confirmar a operação?';
        return (
            <Modal { ...this.props } dialogStyle={{ borderRadius: '4px' }}>
                <div className={`conf-modal-body ${ this.props.bodyClass ? this.props.bodyClass : '' }`}>
                    <div className='conf-modal-text'>
                        {msg}
                    </div>
                    <div className='conf-modal-footer'>
                        <button className='cancel-btn' onClick={this.onCancel}>Não</button>
                        <button className='save-btn' onClick={this.onConfirm}>Sim</button>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default ConfirmationModal;



// WEBPACK FOOTER //
// ./src/components/confirmation-modal/confirmation-modal.js